import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output
} from '@angular/core';
import {
  BookResult
} from 'src/app/models/api_models/book';
import { StationService } from 'src/app/api/station.service';
import { StationDetail } from 'src/app/models/api_models/station';
import { BookCancelConfirmDialogComponent, CancelConfirmData } from '../../book/book-cancel-confirm-dialog/book-cancel-confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-next-book',
  templateUrl: './next-book.component.html',
  styleUrls: ['./next-book.component.scss']
})
export class NextBookComponent implements OnInit {

  _isCurrentBook : boolean = false;
  get isCurrentBook() :boolean {if (this._book != null ) return true; return false;}
  set isCurrentBook(isCurrentBook : boolean) {this._isCurrentBook = isCurrentBook;}

  _isEmpty : boolean = false;
  get isEmpty() : boolean {return this._isEmpty;}
  set isEmpty(isEmpty : boolean ) {this._isEmpty = isEmpty;}

  _startDate : Date = null;
  _endDate : Date = null;

  private _station : StationDetail = null;
  get station() : StationDetail {return this._station;}
  set station(station : StationDetail) {this._station = station;}

  private _book: BookResult = null;
  get book() {
    return this._book;
  }

  @Input()
  set book(book: BookResult) {
    this._book = book;
  }

  private _bookList: BookResult[] = null;
  get bookList(): BookResult[] {
    return this._bookList;
  }

  @Input()
  set bookList(bookList: BookResult[]) {
    this._bookList = bookList;
    this.getNextBook();
  }

  @Output() _openMapEvent = new EventEmitter();
  
  openMap() {
    this._openMapEvent.emit(this._book.station_id);
  }

  private getNextBook() {
    if (this._bookList != null) {
      const d = new Date();
      for (const b of this._bookList) {
        const bookEnd = new Date(b.enddate.replace("Z", ""));
        if (d.getTime() <= bookEnd.getTime() &&
        b.status == "reserved") {
          this._book = b;
        }
        else if (d.getTime() > bookEnd.getTime()) {
          if (this._book != null) {
            const bookstart = new Date(this._book.startdate.replace("Z", ""));
            this._endDate = new Date(this._book.enddate.replace("Z", ""));
            this._startDate = new Date(this._book.startdate.replace("Z", ""));
            if (d.getTime() >= bookstart.getTime()) {
              this._isCurrentBook = true;
              
            }
          }
          break;
        }
      }
    }
    if (this._book == null) {
      this._isEmpty = true;
      
    }
    else {
      // console.log('OK STATION');
              
              this.stationService.getStationDetailFromId(this._book.station_id).subscribe(
                response => {
                  this._station = response;
                }
              )
    }
  }

  public openCancelConfirm() {

    
    if (this._endDate.getTime() > this._startDate.getTime()) {

      const dialogRef = this.dialog.open(BookCancelConfirmDialogComponent, {
        data: new CancelConfirmData(this._book, this._startDate, this._endDate),
      });
      dialogRef.afterClosed().subscribe(
        result => {
          // console.log(result);
        }
      );
    }
  }

constructor(private stationService : StationService, public dialog: MatDialog) {}


ngOnInit() {}

}
